<template>
  <div id="App">
    <div v-if="onload" class="wrap">
      <app-header v-if="notExposure"></app-header>
      <router-view ref="contents" class="container"></router-view>
      <app-footer></app-footer>
    </div>

    <div v-show="!onload || $store.state.btnLoading" class="loader-wrapper">
      <img src="/images/loadingbar.gif" alt="로딩">
    </div>

    <!-- <bottom-nav v-if="$store.state.isDev || Const.TEST_EMAIL.includes($store.state.user.plus_id)"></bottom-nav> -->
    <bottom-nav v-if="Const.TEST_EMAIL.includes($store.state.user.vtg_id) 
      && ['211.44.220.121','172.17.0.1'].includes($store.state.envServer.ip)">
    </bottom-nav>

    <popup-401 v-if="$store.state.popup401"></popup-401>
    
    <PopupAlertGlobal></PopupAlertGlobal>
    <popup-notice v-if="noticePopupActivated" @close="closeNoticePopup()"></popup-notice>

  </div>
</template>


<script>
  // import AppHeaderMenu from './components/AppHeader_menu.vue'
  import AppHeader from './components/AppHeader.vue';
  import AppFooter from './components/AppFooter.vue';
  import BottomNav from './components/BottomNav.vue';
  import Popup401 from "./components/Popup/Popup401.vue";
  import PopupAlertGlobal from "./components/Popup/PopupAlertGlobal.vue";
  import { setTokenFunc } from './mixins/TokenMixin';
  import PopupNotice from "./components/Popup/PopupNotice";

  export default {
    name: 'app',
    
    mixins:[ setTokenFunc ],

    components: {
      // AppHeaderMenu,
      AppHeader,
      AppFooter,
      BottomNav,
      Popup401,
      PopupAlertGlobal,
      PopupNotice,
    },

    computed: {
      notExposure() {
        let isView = false;

        const routeNames = [
          'SubscVtg', //구독정보
          'SubscListItem', //서비스상세
          'SubscRevoke', //서비스해지
          'GuideWarranty', //파워트레인상세
          'GuideTotal', // 구독 신청 방법 및 이용 방법
        ]
        
        isView = !routeNames.includes(this.$route.name);

        if(this.$route.name === 'SubscVtg') {
          isView = this.$route.query.isHead === 'Y';
        }

        return isView;
      }
    },

    data(){
      return {
        noticePopupActivated: this.getNoticePopupActivated(),
      }
    },

    created() {},
    mounted() {},
    
    methods: {
      getNoticePopupActivated(){
        let beginTime = new Date('2022-12-23 10:00').getTime() / 1000;
        let endTime = new Date('2023-01-01 23:59').getTime() / 1000;
        let closedTime = Number(localStorage.getItem('NoticeClosed') || 0) / 1000;
        let now = Date.now()  / 1000;
        return ((now - closedTime) > 86400) && now >= beginTime && now <= endTime;
      },

      closeNoticePopup(){
        this.noticePopupActivated = false;
      }
    }
  };
</script>
